import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import mollieService from "../services/mollie";

/**
 * Composant qui vérifie périodiquement si un paiement en cours a expiré.
 * Ce composant est ajouté à App.js pour une vérification globale.
 */
const PaymentExpirationChecker = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Vérifier s'il y a un paiement en cours
    const paymentId = localStorage.getItem("molliePaymentId");
    const startTime = localStorage.getItem("paymentStartTime");
    const orderId = localStorage.getItem("currentOrderId");

    // Ne pas vérifier si nous sommes déjà sur les pages de paiement
    if (
      location.pathname.includes("/payment-") ||
      location.pathname.includes("/checkout") ||
      !paymentId ||
      !startTime ||
      !orderId
    ) {
      return;
    }

    // Définir la fonction de vérification
    const checkExpiration = () => {
      if (mollieService.isPaymentLikelyExpired(startTime)) {
        console.log(
          "Paiement probablement expiré, redirection vers la page de résultat"
        );
        navigate(`/payment-result?order=${orderId}&status=expired&origin=auto`);
      }
    };

    // Vérifier immédiatement
    checkExpiration();

    // Créer un intervalle de vérification toutes les 30 secondes
    const interval = setInterval(checkExpiration, 30000);

    return () => clearInterval(interval);
  }, [navigate, location.pathname]);

  // Ce composant ne rend rien dans le DOM
  return null;
};

export default PaymentExpirationChecker;
